// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedback__user{gap:12px;margin-bottom:6px;display:flex}.feedback__name{word-break:break-all}.feedback__posted-at{color:#71667f}.feedback__rating{margin-top:2px;margin-left:auto}", ""]);
// Exports
module.exports = exports;
